
  import { mapState } from 'vuex';
  import { values } from 'lodash';

  import search from "@/mixins/search";

  export default {
    name: "ModalRoomTypes",
    mixins: [
      search
    ],
    props: {
      show: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      clear() {
        this.filters.room_types = [];
        this.action();
      },
      action() {
        this.submitSearch({
          data: true,
          redirect: 'properties'
        });
        this.close();
      }
    },
    computed: {
      types() {
        let items = {};
        const trans = this.$t('constants.room_types');

        values(this.includedRoomTypes).map((k) => {
          if (!!trans[k]) {
            items[k] = trans[k]
          }

          return k;
        });

        return items;
      },
      ...mapState({
        includedRoomTypes: state => state.data.getConfigRequest.data.room_types || [],
      }),
    },
    watch: {
      show(newVal) {
        this.initFilters();
        this.isOpen = newVal;
      },
    }
  }
